import { render, staticRenderFns } from "./PhotoBreadcrumb.vue?vue&type=template&id=3f9951de&scoped=true&lang=pug"
import script from "./PhotoBreadcrumb.vue?vue&type=script&lang=js"
export * from "./PhotoBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9951de",
  null
  
)

export default component.exports